<template>
	<div>
		<div class="row mb-2">
			<div class="col-5">
				<h1>{{$t('dashboard')}}</h1>
			</div>
			<div class="col-7">
				<MenuModalBtn class="float-right" />
			</div>
		</div>


		<div class="row">
			<div class="col-md-8">

				<div class="mb-2" v-if="!isTeacher && $UserSession.hasPriv('REPORT_CLINICALEXPERIENCE')">
					<ProgressWidget />
				</div>

				<template v-if="activities_ready">
					<h2 class="mb-2">{{$t('recent-activity')}}</h2>

					<!-- Activity Log -->
					<ScrollPaginator
						:data="activities"
						:submitting="submitting"
						:filters="filters"
						@toPage="toPage"
					>
						<template v-slot:item="{ item: activity }">
							<LogItem :activity="activity" @click="$router.push(`/reflections/view/${activity.id}`)" />
						</template>
					</ScrollPaginator>
 				</template>
 				<template v-else>
 					<div class="skeleton midnight h32 mb-2"></div>
 					<div class="skeleton midnight h32 mb-2"></div>
 					<div class="skeleton midnight h32 mb-2"></div>
 					<div class="skeleton midnight h32 mb-2"></div>
 					<div class="skeleton midnight h32 mb-2"></div>
 				</template>

			</div>

			<div class="col-md-4">

				<div class="widget mb-4 p-8">
					<UserWidget />
				</div>

				<!-- Messages -->
				<MessagesWidget limit="3" unread="1" class="mb-4"></MessagesWidget>

				<!-- Forms -->
				<FormsWidget list="requiringattention" limit="5" :header="$t('action-required')" class="mb-4"></FormsWidget>

				<!-- Timetable -->
				<div class="mb-4" v-if="$config.hasModule('timetable') && !isTeacher && $UserSession.hasPriv('TIMETABLE_VIEW')">
					<TimetableWidget />
				</div>

				<RecentlyMarkedWidget limit="3" v-if="$UserSession.hasPriv('TREATMENTSESSION_EDIT') && !isTeacher" />
			</div>
		</div>

	</div>
</template>

<script>
import MenuModalBtn from "src/components/Workflows/MenuModalBtn.vue";
import UserWidget from "src/components/widgets/UserWidget";
import ProgressWidget from "src/components/widgets/ProgressWidget";
import MessagesWidget from "src/components/widgets/MessagesWidget";
import FormsWidget from "src/components/widgets/FormsWidget"
import RecentlyMarkedWidget from "src/components/widgets/RecentlyMarkedWidget";
import TimetableWidget from "src/components/widgets/TimetableWidget";
import ScrollPaginator from "src/components/Table/ScrollPaginator";
import LogItem from "src/components/Reflections/LogItem.vue";

export default {
	components: {
		MenuModalBtn,
		UserWidget,
		ProgressWidget,
		MessagesWidget,
		FormsWidget,
		RecentlyMarkedWidget,
		TimetableWidget,
		ScrollPaginator,
		LogItem
	},
	data() {
		return {
			searchTerm: null,
			activities_ready: false,
			activities: [],
			submitting: false,
			filters: {
				page: 1,
				page_size: 10,
				total: 1
			}
		};
	},
	mounted() {
		this.listActivities();
	},
	methods: {
		listActivities() {
            if (this.submitting) return;
            this.submitting = true;

			this.$cfetch(`${this.$settings.APIBaseURL}/activitylog/list`, {
				method: 'POST',
				data: this.filters,
			}).then(res => {
				if(res.status == 'SUCCESS'){
					this.activities = res.results
					this.filters.page = res.pagination.page
					this.filters.page_size = res.pagination.page_size
                	this.filters.total = res.pagination.total
					this.activities_ready = true;
				}
			}).catch(err => {
				this.$log.error.call(this, err)
			}).finally(() => {
				this.submitting = false;
			})
		},
		searchTermChange: function(){

		},
        toPage(pageNo) {
            this.filters.page = pageNo
            this.listActivities()
        }
	},
	computed: {
		isTeacher: function() {
			return this.$UserSession.hasPriv.call(this, "APP_TEACHER");
		},
	},
};
</script>
